import { jsx as _jsx } from "react/jsx-runtime";
import { usePage } from '@inertiajs/react';
import { cn } from '@/lib/utils';
/** Logo oficial da Rocket Pages (assets/img). */
export function Brand({ className, mark = false }) {
    const { app } = usePage().props;
    if (mark) {
        return _jsx("img", { src: app.logoMark, alt: "Rocket Pages", className: cn('h-8 w-8', className) });
    }
    return _jsx("img", { src: app.logo, alt: "Rocket Pages", className: cn('h-[26px] w-auto', className) });
}
